// extracted by mini-css-extract-plugin
export default {"modalTabs":"NewPopup_modalTabs__CyIIe","analyticsModal":"NewPopup_analyticsModal__G1HF3","tabContent":"NewPopup_tabContent__wEWLf"};